import { Component } from "@angular/core";
import { faPencil } from "@fortawesome/free-solid-svg-icons";
import { NotifierService } from "angular-notifier";
import { FormField } from "src/app/interfaces/form-field.model";
import { GeneralEnquiryService } from "src/app/services/autopac/general-enquiry-service";

@Component({
  selector: "app-general-enquiry",
  templateUrl: "./general-enquiry.component.html",
  styleUrls: ["./general-enquiry.component.css"],
})
export class GeneralEnquiryComponent {
  faPencil = faPencil;

  constructor(
    private generalEnquiryService: GeneralEnquiryService,
    private notifier: NotifierService,
  ) {}

  searchCriteria: FormField[] = [
    {
      type: "radio",
      id: "searchBy",
      options: [
        { display: "Contract No.", value: 1 },
        { display: "Buyer Order No.", value: 2 },
        { display: "Payee", value: 3 },
        { display: "Buyer Name", value: 4 },
        { display: "Vehicle No.", value: 5 },
      ],
      value: 1,
    },
    {
      type: "search",
      id: "description",
      label: "Description",
      searchEvent: true,
      searchType: "generalEnquiryDescription",
    },
  ];

  searchResult: FormField[] = [
    { type: "text", id: "contractNumber", label: "Contract Number", lock: true },
    { type: "text", id: "buyerOrderNumber", label: "Buyer Order Number", lock: true },
    { type: "text", id: "buyerName", label: "Buyer Name", lock: true },
    { type: "text", id: "chequeDate", label: "Cheque Date", lock: true },
    { type: "text", id: "payTo", label: "Pay To", lock: true },
    { type: "text", id: "amount", label: "Amount", lock: true },
    { type: "text", id: "purpose", label: "Purpose", lock: true },
    { type: "text", id: "bank", label: "Bank", lock: true },
    { type: "text", id: "chequeNumber", label: "Cheque Number", lock: true },
  ];

  general_enquiry_headers = [
    { title: "PAY TO", type: "data", id: "payTo", classes: "max-w-64" },
    { title: "BUYER NAME", type: "data", id: "buyerName", classes: "max-w-64" },
    { title: "CONTRACT NO", type: "data", id: "contractNumber", classes: "max-w-64" },
    { title: "CHEQUE DATE", type: "data", id: "chequeDate", classes: "max-w-64" },
    { title: "CHEQUE NO", type: "data", id: "chequeNumber", classes: "max-w-64" },
    { title: "AMOUNT", type: "data", id: "amount", classes: "max-w-64" },
    { title: "PURPOSE", type: "data", id: "purpose", classes: "max-w-64" },
    { title: "BANK", type: "data", id: "bank", classes: "max-w-64" },
    { title: "BUYER ORDER NO", type: "data", id: "buyerOrderNumber" },
    { title: "CANCEL CHEQUE", type: "data", id: "cancelCheque" },
    { title: "SELECT", type: "edit" },
  ];

  general_enquiry_data: any[] = [];

  search(event: any): void {
    const searchBy = Number(this.searchCriteria.find(f => f.id === "searchBy")?.value ?? 1);
    const description = (this.searchCriteria.find(f => f.id === "description")?.value ?? "")
      .toString()
      .trim();

    if (!description) {
      this.general_enquiry_data = [];
      this.clearSelectedEntry();
      return;
    }

    // Match V1: a new search clears both the previous rows and selected details.
    this.general_enquiry_data = [];
    this.clearSelectedEntry();

    this.generalEnquiryService.searchCheque(searchBy, description).subscribe({
      next: (res) => {
        const raw = res?.body?.d ?? res?.body?.Data ?? res?.body ?? [];
        const list = Array.isArray(raw) ? raw : [];

        this.general_enquiry_data = list.map((x: any) => ({
          payTo: x?.PayTo ?? "",
          buyerName: x?.CustomerName ?? "",
          contractNumber: x?.ContractNo ?? "",
          chequeDate: x?.ChequeDate ?? "",
          chequeNumber: x?.ChequeNo ?? "",
          amount: x?.PayAmount ?? "",
          purpose: x?.Purpose ?? "",
          bank: x?.Bank ?? "",
          buyerOrderNumber: x?.BuyerOrderNo ?? "",
          cancelCheque: x?.CancelCheque ?? "",
          select: "",
        }));
      },
      error: (err) => {
        console.error("General Enquiry search error:", err);
        this.general_enquiry_data = [];
        this.notifier.notify("error", err?.message || "Unable to search cheque records.");
      },
    });
  }

  private clearSelectedEntry(): void {
    this.searchResult.forEach((field) => (field.value = ""));
  }

  editEntry(entry: any): void {
    if (!entry) return;

    const setField = (id: string, value: any) => {
      const field = this.searchResult.find((f) => f.id === id);
      if (field) field.value = value ?? "";
    };

    setField("contractNumber", entry.contractNumber);
    setField("buyerOrderNumber", entry.buyerOrderNumber);
    setField("buyerName", entry.buyerName);
    setField("chequeDate", entry.chequeDate);
    setField("payTo", entry.payTo);
    setField("amount", entry.amount);
    setField("purpose", entry.purpose);
    setField("bank", entry.bank);
    setField("chequeNumber", entry.chequeNumber);
  }

}
